module.exports = __webpack_public_path__ + "static/media/Lekan-image.8603b941.png";